import * as React from "react";
import { useMemo } from "react"; // 1. Import useMemo
import { ProgramClassItem, ProgramResponse } from "../../interfaces/program";
import ProgramClassMonth from "./programclassmonth";

interface ProgramClassListProps {
    classes: Array<ProgramClassItem>;
    program: ProgramResponse;
}

// Grouping by monthOrder, retaining order
function groupByMonthOrder(items: ProgramClassItem[]): ProgramClassItem[][] {
    if (items.length === 0) return [];

    const result: ProgramClassItem[][] = [];
    let currentGroup: ProgramClassItem[] = [items[0]];
    let currentMonthOrder = items[0].monthOrder;

    for (let i = 1; i < items.length; i++) {
        const item = items[i];
        if (item.monthOrder === currentMonthOrder) {
            currentGroup.push(item);
        } else {
            result.push(currentGroup);
            currentGroup = [item];
            currentMonthOrder = item.monthOrder;
        }
    }

    // Push the last group
    result.push(currentGroup);

    return result;
}

const ProgramClassList = ({ classes, program }: ProgramClassListProps) => {
    const grouped = useMemo(() => {
        // console.log("Calculating grouped classes..."); // Optional: for debugging
        return groupByMonthOrder(classes);
    }, [classes]); 

    const classgroups = grouped.map((grp) => (
        <ProgramClassMonth
            program={program}
            classes={grp}
            key={grp[0].programClassId}
        />
    ));

    return <div className="register-classselect">{classgroups}</div>;
};

export default ProgramClassList;
